<template>
  <div class="page-wrapper">
    <return-rate v-p="{api:'report/findReturnRateList'}"></return-rate>
    <flow-rate v-p="{api:'report/flow'}"></flow-rate>
  </div>
</template>

<script>
  import ReturnRate from './components/ReturnRate'
  import FlowRate from './components/FlowRate'
  export default {
    name: "financial",
    components:{
      ReturnRate,
      FlowRate

    }
  }
</script>

<style scoped>

</style>
